import type Highcharts from 'highcharts/highstock';
import { memo } from 'react';
import { setOtherItemsState } from '../../../utils/chartUtils';

interface IProps {
    chart?: Highcharts.Chart;
    name: string;
    color?: string;
    type?: string;
}

export const ChartLegendItem = memo<IProps>(({ chart, name, color, type }) => {
    const getSymbolClass = (isLineChart: boolean) => (isLineChart ? 'tooltip-point-line' : 'tooltip-point-circle');
    const onMouseOver = (name: string) => {
        if (!chart) {
            return;
        }
        setOtherItemsState(chart, 'inactive', name);
    };
    const onMouseOut = () => {
        if (!chart) {
            return;
        }
        setOtherItemsState(chart, 'normal');
    };

    return (
        <div className="chart-legend-item" onMouseOver={() => onMouseOver(name)} onMouseOut={() => onMouseOut()}>
            <div style={{ backgroundColor: color }} className={getSymbolClass(type === 'line')} />
            <div className="text-web-body-regular-lg">{name}</div>
        </div>
    );
});
